import React, { memo } from 'react'
import { Col, Nav } from 'react-bootstrap'

const tabs = [
    {
        key: 'manage_bid',
        label: 'Bid Management'
    },
    {
        key: 'upload_content',
        label: 'Ad Settings'
    }
]

const ContentAuctionTabs = ({ isHTR, auctionType, currentTab, handleSwitchTab, ppc_modal_labels, language, isContentAd }) => {
    if (isHTR && isContentAd) {
        return (
            <Col sm="12">
                <div className="divider mt-2" />
                <div className="d-flex justify-content-center">
                    <Nav className={`nav-line mb-4 ${isHTR ? 'htr' : ''}`} style={{ maxWidth: '255px', width: '100%', justifySelf: 'center', flexGrow: 1 }}>
                        {tabs.map(tab => (
                            <Nav.Link
                                key={tab.key}
                                className={`${currentTab === tab.key ? 'active' : ''} `}
                                onClick={handleSwitchTab(tab.key)}
                                disabled={!tab.key}
                                style={{ padding: '0 10px' }}
                            >
                                <span className="d-flex align-items-center">{tab.label}</span>
                            </Nav.Link>
                        ))}
                    </Nav>
                </div>
            </Col>
        )
    }

    return (
        <div className="divider mt-2">
            <span>{ppc_modal_labels[language].bid_management}</span>
        </div>
    )
}

export default memo(ContentAuctionTabs)
